export function parse(dateString: string) {
  if (dateString === null) return null
  const [, y, m, d] = /^(\d{4})-(\d{2})-(\d{2})/.exec(dateString) || []
  const date = new Date(Date.UTC(parseInt(y), parseInt(m) - 1, parseInt(d)))
  return date
}

export function format(date: Date) {
  return new Intl.DateTimeFormat('default', {
    day: 'numeric',
    month: 'short',
    year: '2-digit',
  }).format(date)
}
